import styled from 'styled-components/macro';

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 970px;
  justify-content: space-between;
  margin: 35px 0;
`;

export const Wrapper = styled.div`
  background: #FFFFFF;
  width: 460px;
  height: 525px;
  border: 1px solid #CED4DA;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  padding: 25px 30px 55px;
`;

export const Title = styled.div`
  color: #293845;
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 15px;
`;

export const Content = styled.div`
  background: #FFFFFF;
  border: 1px solid #D1D1D1;
  box-shadow: inset 0px 2px 2px rgba(0, 0, 0, 0.08);
  border-radius: 3px;
  height: calc(100% - 37px);
`;

export const BenchmarkItem = styled.div`
  margin-bottom: 15px;
`;

export const BenchmarkList = styled.div`
  padding: 50px 0 0 20px;
  position: relative;
  height: 100%;
`;

export const ReviewList = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 7px;
  & > div {
    margin: 0 5px 5px 0;
  }
`;

export const SelectAll = styled.div`
  height: 42px;
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  border-bottom: 1px solid #D8D8D8;
  box-shadow: 0px 1px 4px rgba(216, 216, 216, 0.5);
  padding-left: 20px;
  background: #FFFFFF;
`;

export const Footer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 50px;
  margin-top: 40px;
  & > * {
    margin-left: 10px;
  }
`;